export const CLEAR_COMPOSITES_PAGE = 'CLEAR_COMPOSITES_PAGE';
export const SET_COMPOSITES_PAGE = 'SET_COMPOSITES_PAGE';
export const SET_COMPOSITE = 'SET_COMPOSITE';
